var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("yhdl"),
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "600px",
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "user",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.formValidate,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("djmc"), prop: "level_name" } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("qsrdjmc") },
                model: {
                  value: _vm.formValidate.level_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "level_name", $$v)
                  },
                  expression: "formValidate.level_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("gradeNum"), prop: "level" } },
            [
              _c("el-input", {
                attrs: { type: "number", placeholder: _vm.$t("qsrgradeNum") },
                model: {
                  value: _vm.formValidate.level,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "level", _vm._n($$v))
                  },
                  expression: "formValidate.level",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("jstj"), prop: "lift_type" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formValidate.lift_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValidate, "lift_type", $$v)
                    },
                    expression: "formValidate.lift_type",
                  },
                },
                [
                  _c(
                    "p",
                    { staticClass: "margin_bottom_12" },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("wzdjs"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "margin_bottom_8" },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("zchy"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "margin_bottom_8" },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: 2 } },
                        [
                          _vm._v(_vm._s(_vm.$t("ljcz")) + "\n            "),
                          _c("el-input", {
                            staticStyle: {
                              width: "150px",
                              "margin-left": "12px",
                            },
                            attrs: {
                              size: "mini",
                              placeholder: "请输入累计充值金额",
                            },
                            model: {
                              value: _vm.formValidate.lift_condition,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "lift_condition",
                                  _vm._n($$v)
                                )
                              },
                              expression: "formValidate.lift_condition",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "margin_bottom_8" },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: 3 } },
                        [
                          _vm._v(_vm._s(_vm.$t("ljxf")) + "\n            "),
                          _c("el-input", {
                            staticStyle: {
                              width: "150px",
                              "margin-left": "12px",
                            },
                            attrs: {
                              size: "mini",
                              placeholder: "请输入累计消费",
                            },
                            model: {
                              value: _vm.formValidate.lift_condition,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "lift_condition",
                                  _vm._n($$v)
                                )
                              },
                              expression: "formValidate.lift_condition",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: _vm.$t("hyqy") } }, [
            _c(
              "p",
              { staticClass: "margin_bottom_8 flex-start" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.formValidate.vip_withdraw_rate_status,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "vip_withdraw_rate_status",
                          $$v
                        )
                      },
                      expression: "formValidate.vip_withdraw_rate_status",
                    },
                  },
                  [_vm._v("赔率叠加")]
                ),
                _vm._v(" "),
                _c(
                  "el-input",
                  {
                    staticClass: "margin_left_7",
                    attrs: {
                      type: "number",
                      maxlength: 3,
                      placeholder: _vm.$t("qsrtxfl"),
                    },
                    model: {
                      value: _vm.formValidate.vip_withdraw_rate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "vip_withdraw_rate", $$v)
                      },
                      expression: "formValidate.vip_withdraw_rate",
                    },
                  },
                  [
                    _c("i", { attrs: { slot: "suffix" }, slot: "suffix" }, [
                      _vm._v("%"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "red" }, [
              _vm._v(
                "\n        \n        " + _vm._s(_vm.$t("zhuyi")) + "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "margin_bottom_8 flex-start" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.formValidate.vip_compensate_rate_status,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "vip_compensate_rate_status",
                          $$v
                        )
                      },
                      expression: "formValidate.vip_compensate_rate_status",
                    },
                  },
                  [_vm._v("提现费率")]
                ),
                _vm._v(" "),
                _c(
                  "el-input",
                  {
                    staticClass: "margin_left_7",
                    attrs: {
                      type: "number",
                      maxlength: 3,
                      placeholder: _vm.$t("qsrpldj"),
                    },
                    model: {
                      value: _vm.formValidate.vip_compensate_rate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "vip_compensate_rate", $$v)
                      },
                      expression: "formValidate.vip_compensate_rate",
                    },
                  },
                  [
                    _c("i", { attrs: { slot: "suffix" }, slot: "suffix" }, [
                      _vm._v("%"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "red" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("txzhuyi")) + "\n      "),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("user")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calcelText")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }